var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('div',{style:(_vm.style)},[_c('p',{staticStyle:{"color":"#aaa","font-size":"14px"}},[_vm._v("Banner")])])])}
var staticRenderFns = []

export { render, staticRenderFns }